<template>
  <div id="location">
    <div class="main">
      <div class="wrapper mx-auto flex flex-wrap">

        <div class="w-full md:w-3/5 px-4 md:px-8 xl:px-4">
          <h1 class="animated fadeIn">{{title}}</h1>
          <h2 v-if="locData" class="animated fadeIn delay-200">{{locData.address}}, {{locData.city}}, {{locData.state}} {{locData.zipcode}}</h2>

          <div v-if="locData" class="flex flex-wrap mt-6 sm:mt-8 mb-6 sm:mb-4 sm:text-base animated fadeIn delay-400">
            <div v-if="!comingSoon" class="w-full md:w-1/2 flex items-center mb-4 h-10">
              <img src="~/assets/img/icons/clock.svg" alt="Clock Icon" width="32" height="32" class="mr-3 sm:mr-4 md:mr-6" />
              {{getTodayHours()}}
            </div>
            <div v-if="telephone" class="w-full md:w-1/2 flex items-center md:pl-6 h-10">
              <img src="~/assets/img/icons/mobile-phone.svg" alt="Phone Icon" height="43" width="25" class="mr-3 sm:mr-4 md:mr-6 ml-1 sm:ml-0" />
              {{telephone}}
            </div>
          </div>

          <div v-if="comingSoon">
            Coming soon
          </div>
          <div v-else-if="locData" class="hours flex flex-wrap animated fadeIn delay-600">
            <div class="w-auto flex-1 leading-tight mr-4" style="max-width: 220px">
              <div class="flex sm:text-base leading-normal" v-for="(v, k) in days[0]" :key="k">
                <div style="width:44px">{{v}}</div>
                <div class="w-2/3 text-right">{{getHours(k)}}</div>
              </div>
            </div>
            <div class="w-auto flex-1 leading-tight" style="max-width: 220px">
              <div class="flex sm:text-base leading-normal" v-for="(v, k) in days[1]" :key="k">
                <div style="width:44px">{{v}}</div>
                <div class="w-2/3 text-right">{{getHours(k)}}</div>
              </div>
            </div>
          </div>

          <div class="flex flex-wrap my-6 sm:text-base animated fadeIn delay-800">
            <div class="w-1/2">Follow us:
              <div class="social">
                <a target="_blank" :href="twitterLink"><img src="~/assets/img/icons/twitter-white.png" alt="Twitter"/></a>
                <a target="_blank" v-if="locData" :href="locData.facebookInfo.facebookPageUrl"><img src="~/assets/img/icons/facebook-white.png" alt="Facebook"/></a>
                <a target="_blank" v-else href="https://www.facebook.com/MyMainEvent"><img src="~/assets/img/icons/facebook-white.png" alt="Facebook"/></a>
                <a target="_blank" :href="instaLink"><img src="~/assets/img/icons/instagram-white.png" alt="Instagram"/></a>
              </div>
            </div>
            <!-- <div class="w-1/2">Read Reviews
              <div class="reviews">
                <img src="~/assets/img/icons/star.svg" alt="Star"/>
                <img src="~/assets/img/icons/star.svg" alt="Star" />
                <img src="~/assets/img/icons/star.svg" alt="Star"/>
                <img src="~/assets/img/icons/star.svg" alt="Star"/>
                <img src="~/assets/img/icons/star.svg" alt="Star"/>
              </div>
            </div> -->
          </div>

          <div class="flex flex-wrap max-w-full mb-6 loc-btn-wrapper animated fadeIn delay-1000">
            <div class="flex sm:flex-col w-full sm:w-auto">
              <nuxt-link to="/book/birthday/" class="mb-2 mr-2 sm:mr-0"><button class="pulse">Book a Party</button></nuxt-link>
              <!-- <nuxt-link class="p-2" to="/book/event/"><button>Book an Event</button></nuxt-link>
              <nuxt-link class="p-2" to="/book/lane/"><button>Book a Bowling Lane</button></nuxt-link>
              <a class="p-2" :href="'https://www.google.com/maps/dir//'+locationURI" target="_blank"><button>Get Directions</button></a> -->
              <a href="https://www.maineventmenu.com/" class="ml-2 sm:ml-0"><button class="pulse">View Menu</button></a>
            </div>
            <div class="border-white border-2 p-3 flex-1 sm:ml-6 w-full sm:w-auto sm:mt-0 mt-4 location-good-for">
              <b class="uppercase">Good For:</b>
              <p>Family-Friendly Fun, Great Burgers, &amp; Watching Sports</p>
            </div>
          </div>
        </div>

        <div class="w-full md:w-2/5 px-4 md:px-8 xl:px-0 animated fadeIn delay-200">
          <!-- <location-map v-if="locData" :locations="[locData]" /> -->
          <img :src="location.fields.mapImages.fields.file.url" alt="Location Map" />
        </div>

      </div>
    </div>

    <div class="lines-bg pt-5 sm:pt-12">
      <div v-if="!comingSoon" class="wrapper mx-auto px-2 md:px-8 xl:px-0">
        <h3 class="section-heading magenta animated fadeIn delay-1200">Experiences at {{title}}</h3>
        <!-- <div class="flex flex-wrap activities">
          <div v-for="(a, i) in activities" :key="i" :class="`w-1/2 md:w-1/4 animated fadeIn delay-${200 + (200 * i)}`">
            <nuxt-link :to="`/experiences/${a.fields.slug}/`" :title="a.fields.title" v-if="activities.length < 4 || i * .25 < Math.floor(activities.length / 4)">
              <default-picture
                :sizes="[]"
                :defaultImg="a.fields.cardMobile.fields.file.url"
                :description="a.fields.title"
                cssClass="mx-auto activity" />
            </nuxt-link> 
          </div>
        </div> -->

        <div class="activity-slider">
          <slider :arrows="true" v-bind="settings">

            <template #prevArrow>
              <img src="~/assets/img/icons/caret-left-purple.svg" alt="Prev">
            </template>

            <template #nextArrow>
              <img src="~/assets/img/icons/caret-right-purple.svg" alt="Next">
            </template>

            <div v-for="(a, i) in activities" :key="i" :class="` animated fadeIn delay-${200 + (200 * i)}`">
              <default-picture
                v-if="a.fields.clickable === 'False'"
                :sizes="[]"
                :defaultImg="a.fields.cardMobile.fields.file.url"
                :description="a.fields.title"
                cssClass="mx-auto activity" />
              <nuxt-link :to="a.fields.linkTo ? a.fields.linkTo : `/experiences/${a.fields.slug}/`" :title="a.fields.title" v-else>
                <default-picture
                  :sizes="[]"
                  :defaultImg="a.fields.cardMobile.fields.file.url"
                  :description="a.fields.title"
                  cssClass="mx-auto activity" />
              </nuxt-link> 
            </div>

          </slider>
        </div>

        <nuxt-link to="/experiences/">
          <div class="opacity-0" v-animate-onscroll="'animated fadeIn'">
            <button class="magenta mx-auto mt-4 mb-10 sm:mb-16 pulse px-2 sm:px-4">Learn More About Our Experiences</button>
          </div>
        </nuxt-link>

      </div>

      <div v-if="location.fields.middleText" class="opacity-0 middle-text" v-animate-onscroll="'animated fadeIn'">
        <div class="bg-dark-blue">
          <div class="wrapper mx-auto px-2 md:px-8 xl:px-0">
            <body-copy class="opacity-0 delay-200" v-animate-onscroll="'animated fadeIn'" :content="location.fields.middleText.content" />
          </div>
        </div>
      </div>
        
      <div v-if="!comingSoon" class="wrapper mx-auto px-2 md:px-8 xl:px-0">

        <!-- <h3 class="section-heading purple">Events</h3>
        <div class="flex flex-wrap -mx-1 sm:-mx-2 mb-6 animate-events">
          <div v-for="e in this.location.events.entries" :key="e.index" class="w-1/2 md:w-1/3 lg:w-1/4">
            <article-card
              btnText="Learn More"
              :href="`/events/${e.fields.slug}`"
              :title="e.fields.title"
              :date="e.fields.date"
              :blurb="e.fields.description"
              featureImageMobile="//placehold.it/286x160" />
          </div>
        </div> -->

        <!-- <nuxt-link to="/events/">
          <div class="opacity-0" v-animate-onscroll="'animated fadeIn'">
            <button class="blue mx-auto pulse mb-16">View More Events</button>
          </div>
        </nuxt-link> -->

        <h3 class="section-heading magenta mt-0 opacity-0" v-animate-onscroll="'animated fadeIn'">What others are saying</h3>

        <feedback-slider class="pb-6" :slides="location.testimonials.entries" />
      </div>

      <coming-soon-form v-if="comingSoon" class="sm:mt-6" :sendKey="title"/>
      <contact-form v-else class="sm:mt-6"/>

      <text-section class="mt-16" :text1="location.fields.leftTextBox.content" :text2="location.fields.rightTextBox.content" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import LocationMap from '~/components/locations/LocationMap.vue'
import FeedbackSlider from '~/components/common/FeedbackSlider.vue'
import ContactForm from '~/components/common/ContactForm.vue'
import ComingSoonForm from '~/components/common/ComingSoonForm.vue'
import ArticleCard from '~/components/stories/ArticleCard.vue'
import DefaultPicture from '~/components/common/DefaultPicture'
import TextSection from '~/components/common/TextSection'
import states from '~/assets/config/states'
import Slider from 'vue-slick-carousel'
import BodyCopy from '~/components/common/BodyCopy'

export default {
  components: {
    LocationMap,
    FeedbackSlider,
    ContactForm,
    ComingSoonForm,
    ArticleCard,
    DefaultPicture,
    TextSection,
    Slider,
    BodyCopy
  },
  data: function() {
    return {
      days: [
        {
          'monday': 'MON',
          'tuesday': 'TUES',
          'wednesday': 'WED',
          'thursday': 'THUR'
        },
        {
          'friday': 'FRI',
          'saturday': 'SAT',
          'sunday': 'SUN'
        }
      ],
      settings: {
        arrows: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2,
            }
          },
        ]
      }
    }
  },
  async validate({ $api, params }) {
    return await $api.getLocation(params.id)
  },
  async asyncData({ $api, params }) {
    return {
      location: await $api.getLocation(params.id)
    }
  },
  head: function() {
    return this.$metadata(this.location)
  },
  methods: {
    getTodayHours() {
      let hours = this.getHours()
      if(hours == 'Closed') {
        return 'Closed Today'
      } else {
        return `Open Today from ${hours}`
      }
    },
    getHours(day = null) {
      try {
        if(!day) {
          // if day isn't set, look for today
          day = moment().format('dddd').toLowerCase()
        }
        if(this.location.fields.hours[day].isClosedWholeDay == true) {
          return 'Closed'
        } else {
          let hours = this.location.fields.hours[day]
          let open = hours.openIntervals[0].start.split(':')
          let openTime = moment().hour(open[0]).minute(open[1])
          let closed = hours.openIntervals[hours.openIntervals.length - 1].end.split(':')
          let closedTime = moment().hour(closed[0]).minute(closed[1])
          return `${openTime.format(`h${openTime.minute() > 0 ? ':mm' : ''} a`)} - ${closedTime.format(`h${closedTime.minute() > 0 ? ':mm': ''} a`)}`
        }
      } catch(err) {
        // console.error(err)
        return 'N/A'
      }
    },
    resizeArticleCards() {
      let cards = document.querySelectorAll('.article-card-body')
      let i
      for (i = 0; i < cards.length; i++) {
        cards[i].removeAttribute('style')
        if (i == 0) {
          this.minHeight = cards[i].offsetHeight
        } else {
          if (cards[i].offsetHeight > cards[i-1].offsetHeight) {
            if (cards[i].offsetHeight > this.minHeight) {
              this.minHeight = cards[i].offsetHeight
            }
          }
        }
      }
      for (i = 0; i < cards.length; i++) {
        cards[i].style.minHeight = this.minHeight + 'px'
      }
      if (this.minHeight < 180) {
        this.minHeight = 180
      }
    },
  },
  computed: {
    instaLink() {
      let link = ''
      this.$store.state.info.menus.social.fields.children.map(l => {
        if(l.fields.title == 'Instagram') {
          link = l.fields.url
        }
      })
      return link
    },
    twitterLink() {
      let link = ''
      this.$store.state.info.menus.social.fields.children.map(l => {
        if(l.fields.title == 'Twitter') {
          link = l.fields.url
        }
      })
      return link
    },
    telephone() {
      return this.location.fields.locationData && this.location.fields.locationData.telephone ? this.location.fields.locationData.telephone.replace(/\+1(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : ''
    },
    locData() {
      return this.location.fields.locationData
    },
    locationURI() {
      let address = this.location.address+', '+this.location.city+', '+this.location.state+' '+this.location.zipcode
      return encodeURIComponent(address)
    },
    activities() {
      let activities = []
      
      try {
        this.location.activities.entries.map(a => {
          if(!a.fields.identifier || this.location.fields.venues[a.fields.identifier] == true) {
            activities.push(a)
          }
          if(this.location.fields.extraVenues) {
            if(this.location.fields.extraVenues.indexOf(a.fields.identifier) > -1) {
              activities.push(a)
            }
          }
        })
      } catch(err) {
        // console.error(err)
        activities = [].concat(this.location.activities.entries)
      }
      
      return activities
    },
    title() {
      return this.location.fields.title //this.location.centerName.replace('Main Event - ', '')
    },
    comingSoon() {
      return this.location.fields.comingSoon == true
    }
  },
  mounted() {
    window.addEventListener("resize", this.resizeArticleCards)
    this.$nextTick(() => {
      this.resizeArticleCards()
    })
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeArticleCards)
  },
  watch: {
    // '$route.path': function(e) {
    //   this.current = e
      // console.log('route change:', e)
    // }
  }
}
</script>

<style lang="scss">
  @import '../../../assets/scss/variables';

  .activity-slider {
    margin-left: -10px;
    margin-right: -10px;

    @media (max-width: $md) {
      padding: 0 6px;
      margin-bottom: -12px;
    }

    * {
      outline: 0;
    }

    .slick-arrow {
      position: absolute;
      top: 50%;
      margin-top: -32px;
      cursor: pointer;
      left: -26px;
      z-index: 2;
      padding: 10px;


      @media (min-width: 1324px) {
        left: -40px;
      }

      @media (max-width: $md) {
        background: rgba(255, 255, 255, 0.8);
        padding: 15px;
        left: 3px;
        margin-top: -34px;
      }
    }

    .slick-next {
      left: unset;
      right: -26px;

      @media (min-width: 1324px) {
        right: -40px;
      }

      @media (max-width: $md) {
        right: 3px;
      }
    }
    
    .activity {
      padding: 8px;
      width: 100%;

      img {
        width: 100%;
        margin: 0;
      }
    }
  }

  #location {
    .middle-text {
      > div {
        max-width: 100%;
        padding: 2.5em 5px 2em 5px;
        margin-top: -20px;
        margin-bottom: 25px;
        @media (min-width: $md) {
          margin-top: -20px;
          margin-bottom: 55px;
        }
      }
      .wrapper {
        max-width: 100%;
      }
      h3 {
        font-size: 18px;
        font-weight: 900;
        margin-bottom: 10px;
        line-height: 1.3em;
        @media (min-width: $md) {
          line-height: unset;
        }
      }
      font-size: 14px;
      color: #fff;
      @media (min-width: $md) {
        font-size: 16px;
      }
    }
  }
</style>